const CLIENT_ID = "CLIENT_ID";
const API_END_POINT = "API_END_POINT";
const AUTH_BACKEND = "AUTH_BACKEND";

export const LANG_KEY = "LANG_KEY";

export const setLanguage = (lang: string) => {
  localStorage.setItem(LANG_KEY, lang);
};

export const getClientId = () => {
  return localStorage.getItem(CLIENT_ID);
};

export const setCustomAPIEndPoint = (value: string) => {
  localStorage.setItem(API_END_POINT, value);
};

export const getCustomAPIEndPoint = () => {
  return localStorage.getItem(API_END_POINT);
};

export const setCustomAuthBackend = (value: string) => {
  localStorage.setItem(AUTH_BACKEND, value);
};

export const getCustomAuthBackend = () => {
  return localStorage.getItem(AUTH_BACKEND);
};
